import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		sectionHeader: {
			fontWeight: "bold",
			fontSize: 18,
		},
		fieldLabel: {
			color: theme.palette.text.secondary,
			fontSize: 16,
			marginBottom: 16,
			display: "flex",
			alignItems: "center",
			gap: 8,
		},
		sectionDescription: {
			color: theme.palette.text.secondary,
			marginTop: 4,
		},
		chipContainer: {
			display: "flex",
			flexWrap: "wrap",
			gap: 8,
			marginTop: 8,
		},
		linkRow: {
			display: "flex",
			gap: 24,
			marginTop: 8,
		},
	} satisfies Record<string, CSSObject>);
};
